import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const UserPlatformUserDropdown = ({
    errors,
    touched,
    darkMode,
    platformUsers,
    assigningPlatformUserId,
    setAssigningPlatformUserId,
}) => {
    const handleSelectChange = (item) => {
        setAssigningPlatformUserId(item?.primaryUserID);
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors.platformUserDropdown && touched.platformUserDropdown
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>User</FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id="platformUserDropdown"
                    name="platformUserDropdown"
                    shownValue="displayName"
                    darkMode={darkMode}
                    currentId={assigningPlatformUserId}
                    selectedId="primaryUserID"
                    handleSelectChange={handleSelectChange}
                    data={platformUsers}
                    data-walkthroughid={
                        walkthroughIds.edit.ufVoicePolicyDropdown
                    }
                    validate={() => {
                        if (!assigningPlatformUserId) {
                            return 'Please select a User';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Select a Platform User to assign them to this User"
                        ariaLabel="users-platform-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformUserDropdown;
